var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',[_vm._v("PAGE NOT FOUND 404")]),_c('router-link',{staticClass:"btn btn-neon error-btn",attrs:{"to":"/"}},[_vm._v("BACK TO HOME PAGE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }